import React, { useState } from 'react';
import { CRM_COLORS } from '../theme/crmColors';
import { AvatarAncList } from '../components/avatarAnc/list';
import Authentication from '../components/auth/Authentication';
import { ancs, redirect_to_ancs } from './paths';
import { User } from '../utils/types';
import { useSelector } from 'react-redux';
import { CustomReducerState } from '../redux/reducers';
import IntegratedHeader from '../components/header/IntegratedHeader';
import ViewToggle, { ViewMode } from '../components/avatarAnc/ViewToggle';
import { useTranslate } from 'react-admin';
import { Box } from '@material-ui/core';

const AvatarAncPage = () => {
    const userConnected: User | null = useSelector((state: CustomReducerState) => state.rikutec.users.userConnected);
    const translate = useTranslate();
    const [viewMode, setViewMode] = useState<ViewMode>('cards');

    return (
        <Authentication redirectTo={redirect_to_ancs}>
            {userConnected && (
                <Box
                    style={{
                        height: '100vh',
                        display: 'grid',
                        gridTemplateRows: 'auto 1fr',
                        gridTemplateColumns: 'minmax(0, 1fr)',
                        overflowX: 'hidden',
                        backgroundColor: CRM_COLORS.background,
                    }}
                >
                    <IntegratedHeader
                        currentPath={ancs}
                        eyebrow={translate('app.headers.eyebrow.realTime')}
                        title={translate('app.headers.ancs')}
                        actions={<ViewToggle viewMode={viewMode} setViewMode={setViewMode} />}
                    />

                    <Box
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            minWidth: 0,
                            minHeight: 0,
                            height: '100%',
                        }}
                    >
                        <AvatarAncList viewMode={viewMode} />
                    </Box>
                </Box>
            )}
        </Authentication>
    );
};

export default AvatarAncPage;
